

/// <reference path="VenueEvent.ts" />

// Generated class BookingEvent_ManagedObject

class BookingEvent_ManagedObject extends VenueEvent
{

    // Relationship: bookings
    protected _bookings:MIOManagedObjectSet = null;
    get bookings():MIOManagedObjectSet {
        return this.valueForKey('bookings');
    }
    addBookingsObject(value:Booking) {
        this._addObjectForKey(value, 'bookings');
    }
    removeBookingsObject(value:Booking) {
        this._removeObjectForKey(value, 'bookings');
    }
}
